var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-form",
        {
          ref: "form",
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submit.apply(null, arguments)
            },
          },
          model: {
            value: _vm.valid,
            callback: function ($$v) {
              _vm.valid = $$v
            },
            expression: "valid",
          },
        },
        [
          _c("FormItem", {
            scopedSlots: _vm._u([
              {
                key: "question",
                fn: function () {
                  return [_vm._v("Who's going?")]
                },
                proxy: true,
              },
              {
                key: "end",
                fn: function () {
                  return [
                    _c(
                      "div",
                      {
                        staticClass:
                          "text-body-1 font-weight-regular text-align-end",
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              `${
                                _vm.eventRegister.details.capacity -
                                _vm.eventRegister.details.attending -
                                _vm.eventRegister.details.pending -
                                _vm.form.attending.length +
                                (_vm.eventRegister.attendingInCart?.quantity ??
                                  0)
                              } seats available`
                            ) +
                            "\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "text-sm font-weight-regular text-align-end",
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              `Reserving ${_vm.form.attending.length} seat(s)`
                            ) +
                            "\n                "
                        ),
                      ]
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "action",
                fn: function () {
                  return [
                    _c(
                      "v-row",
                      { staticClass: "gap-2", attrs: { "no-gutters": "" } },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "soli-round",
                                attrs: {
                                  "x-small": "",
                                  outlined: "",
                                  color: "accent",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.relationshipForm = true
                                  },
                                },
                              },
                              [_vm._v("Add Relationship")]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "response",
                fn: function () {
                  return [
                    _c("v-autocomplete", {
                      staticClass: "soli-blue-text",
                      attrs: {
                        items: _vm.relationships,
                        "no-data-text": "No relationships found",
                        multiple: "",
                        chips: "",
                        "deletable-chips": "",
                        "item-text": "name",
                        "item-value": "id",
                        label: "Your relationships",
                        outlined: "",
                        "prepend-inner-icon": "people",
                        "error-messages": _vm.errors.attending,
                        "hide-details": "auto",
                        rules: [
                          (val) =>
                            val.length <=
                              _vm.eventRegister.details.capacity -
                                _vm.eventRegister.details.pending -
                                _vm.eventRegister.details.attending ||
                            "This event is over capacity, please contact us to join the waitlist",
                          (val) =>
                            !!(val || "").length > 0 ||
                            "This field is required",
                        ],
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "item",
                          fn: function (data) {
                            return [
                              _c("v-list-item-avatar", [
                                _c("img", {
                                  attrs: { src: data.item.profile_photo_url },
                                }),
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", {
                                    domProps: {
                                      innerHTML: _vm._s(data.item.name),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("v-list-item-subtitle", {
                                    domProps: {
                                      innerHTML: _vm._s(data.item.email),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                      model: {
                        value: _vm.form.attending,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "attending", $$v)
                        },
                        expression: "form.attending",
                      },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _vm._v(" "),
          _c("FormSubmit", {
            attrs: {
              loading: _vm.loading,
              errors: _vm.errors,
              valid: "",
              dark: "",
              type: "submit",
              gradient: "gradient-orange",
              icon: "send",
              text: "Checkout",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.relationshipForm
        ? _c("GuestCreateRelationship", {
            attrs: {
              guest: _vm.guest,
              user: _vm.user,
              relationships: _vm.relationships,
            },
            on: {
              success: function ($event) {
                ;[
                  _vm.closeModal(() => (_vm.relationshipForm = false)),
                  _vm.form.attending.push(_vm.relationships[0].id),
                ]
              },
              reset: function ($event) {
                _vm.closeModal(() => (_vm.relationshipForm = false))
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }